import axios from '../utils/axios';

export const uploadMultipleFile = async (form) => {
  const response = await axios.post("/api/Upload/SaveMedia", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  console.log(response.data.listImages);
  return {
    result: response.data.listImages,
  };
};


export const uploadSingleFile = async(form)=>{
  const response = await axios.post("/api/Upload/UploadFile", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  // console.log(response.data);
  return {
    result: response.data,
  };
};